import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { LangProvider } from "@/lib/LangContext";
import { AuthProvider } from "@/lib/auth";
import usePlausible from "@/lib/usePlausible";
import { captureAttribution } from "@/lib/utm";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Certifications from "@/pages/Certifications";
import StartProject from "@/pages/StartProject";

function AnalyticsBoot() {
  usePlausible();
  React.useEffect(() => {
    captureAttribution();
  }, []);
  return null;
}

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <AnalyticsBoot />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/start" element={<StartProject />} />
            <Route path="/case/:slug" element={<Navigate to="/" replace />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Toaster theme="dark" position="bottom-right" />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}
